import WrappingFloatingInspector from "./WrappingFloatingInspector";
export default WrappingFloatingInspector;